import React from "react";
import Supplier from "./Supplier/Supplier";
import "./Catalog.scss";
import Project from "./Project/Project";
import PaymentSource from "./PaymentSource/PaymentSource";
import BugdetSource from "./BudgetSource/PaymentSource";
const Catalog = () => {
  return (
    <div className="propose-shopping-catalog">
      <Supplier></Supplier>
      <Project></Project>
      <PaymentSource></PaymentSource>
      <BugdetSource></BugdetSource>
    </div>
  );
};
export default Catalog;
